// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
//  // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBNe_eOmh0q_NSSBR2OO5Nqgx7pCweLMf8",
//   authDomain: "osl-door.firebaseapp.com",
//   databaseURL: "https://osl-door-default-rtdb.firebaseio.com",
//   projectId: "osl-door",
//   storageBucket: "osl-door.appspot.com",
//   messagingSenderId: "896647983106",
//   appId: "1:896647983106:web:113f9c3bb6f242b6ce771b",
//   measurementId: "G-FDQHQGZP72"
  

// };

// export const app = initializeApp(firebaseConfig)

// import React from 'react'

// export default function firebase() {
//   return (
//     <div>
      
//     </div>
//   )
// }

import {initializeApp} from 'firebase/app'

const firebaseConfig = {
  apiKey: "AIzaSyBNe_eOmh0q_NSSBR2OO5Nqgx7pCweLMf8",
  authDomain: "osl-door.firebaseapp.com",
  databaseURL: "https://osl-door-default-rtdb.firebaseio.com",
  projectId: "osl-door",
  storageBucket: "osl-door.appspot.com",
  messagingSenderId: "896647983106",
  appId: "1:896647983106:web:113f9c3bb6f242b6ce771b",
  measurementId: "G-FDQHQGZP72"
};

export const app = initializeApp(firebaseConfig);